import { IntegrationCore } from 'types/Integration';
import { Undef } from 'types/UtilityTypes';
import { TMS } from 'types/enums/Integrations';

/** McLeod Enterprise or McLeod (Innovation) — load-building UIs must resolve the same integration the tab selected. */
export function getMcleodIntegrationFromList(
  integrations: Undef<readonly IntegrationCore[]>
): Undef<IntegrationCore> {
  if (!integrations?.length) {
    return undefined;
  }
  return integrations.find(
    (i) => i.name === TMS.McleodEnterprise || i.name === TMS.Mcleod
  );
}
